/**
 * Gravity Forms Honeypot Patch Fix.
 *
 * If the Honeypot field is being used and shows up in any order other than last,
 * it can cause display issues with forms that are intended to be a set number of columns.
 * This only applies to Legacy Markup and can be removed if/when we transition away from it.
 *
 * @see https://brightfirellc.atlassian.net/browse/ST-59
 */
( function( $ ) {
	"use strict";

	// Get all Legacy Markup Gravity Forms on the page.
	let $forms = $( '.gform_wrapper.gform_legacy_markup_wrapper form' );

	if ( 0 === $forms.length ) {
		// No forms? Short-circuit.
		return;
	}

	// Loop through all the forms on the page.
	$forms.each( function() {
		let $form = $( this );
		let $fieldsWrapper = $form.find( '.gform_fields' );
		let $honeypot = $fieldsWrapper.find( '.gfield--type-honeypot' );

		if ( 0 === $honeypot.length ) {
			// No honeypot? Short-circuit.
			return;
		}

		// Get the complete markup of the Honeypot field.
		let honeypotMarkup = $honeypot.prop( 'outerHTML' );

		// Remove the existing Honeypot. This could be anywhere in the field list.
		$honeypot.remove();

		// Append the copy of the Honeypot field to the very end.
		$fieldsWrapper.append( honeypotMarkup );
	} );

} )( jQuery );
